import { Icon } from './Icon'

const VALORES = [
  { icone: 'target', nome: 'Visionária', texto: 'Olhamos além do hoje e buscamos oportunidades para o futuro.' },
  { icone: 'gear', nome: 'Resolutiva', texto: 'Problemas precisam de solução. Buscamos caminhos práticos.' },
  { icone: 'chart', nome: 'Inconformada', texto: 'Não aceitamos que “sempre foi assim”. Se pode melhorar, a gente encontra.' },
  { icone: 'users', nome: 'Parceira', texto: 'Caminhamos ao lado do cliente em todas as etapas.' },
]

export function About() {
  return (
    <section className="about" id="sobre">
      <div className="shell about__inner">
        <div className="about__head">
          <p className="eyebrow eyebrow--dark" data-reveal="up"><i />Sobre a Skyenex</p>
          <h2 className="h2" data-reveal="mask">
            Tecnologia ajuda.<br /><span className="accent">Pessoas transformam.</span>
          </h2>
          <p data-reveal="up" data-delay="130">
            A Skyenex nasceu para caminhar ao lado de empreendedores que querem transformar seus
            negócios. Unimos tecnologia, inteligência e gestão para organizar operações, identificar
            oportunidades e construir caminhos para o crescimento.
          </p>
        </div>

        <ul className="about__values">
          {VALORES.map((v, i) => (
            <li data-reveal="up" data-delay={i ? String(i * 80) : undefined} key={v.nome}>
              <span><Icon name={v.icone} /></span>
              <b>{v.nome}</b><small>{v.texto}</small>
            </li>
          ))}
        </ul>

        <div className="about__photo" data-reveal="up" data-delay="200">
          <span className="script script--5">Queremos crescer<br />ajudando outros<br />negócios a crescer.</span>
        </div>
      </div>
    </section>
  )
}
